/**
 * 'Users.store.js'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

export default {
  user: [{path: ''}]}



// WEBPACK FOOTER //
// ./src/store/modules/users.store.js